<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
        <el-button
          slot="reference"
          type="danger"
          size="mini"
          style="margin-left: 10px"
          @click="openDelete"
        >删除</el-button>
    </div>
    <div class="head_search">
      <div class="item_warp">
      <label style="margin: 0 10px">审核状态</label>
      <el-select
        v-model="checkStatus"
        style="width: 120px"
        placeholder="请选择"
        clearable
      >
        <el-option label="不限" value=""></el-option>
        <el-option label="未审核" :value="0"></el-option>
        <el-option label="审核通过" :value="1"></el-option>
        <el-option label="审核不通过" :value="2"></el-option>
      </el-select>
    </div>
    <div class="item_warp">
      <label style="margin: 0 10px">发布状态</label>
      <el-select
        v-model="publishStatus"
        style="width: 120px"
        placeholder="请选择"
        clearable
      >
        <el-option label="不限" value=""></el-option>
        <el-option label="等待" :value="0"></el-option>
        <el-option label="已发布" :value="1"></el-option>
      </el-select>
    </div>
    <div class="item_warp">
      <label style="margin: 0 10px">标题</label>
      <el-input
        v-model="title"
        placeholder="请输入标题"
        style="width: 150px"
        size="mini"
        clearable
      />
    </div>
   
  </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1111px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="editPopup(scope.row)"
            >详情</el-button
          >
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="170">
        <template slot-scope="scoped">
          <div style="display: flex;align-items: center;justify-content: center;" v-if="scoped.row.checkStatus == 0">
              <el-button type="success" size="mini" @click="checkSuccessList(1,scoped.row)">审核通过</el-button>
              <el-button type="danger" size="mini" @click="checkRejectList(1,scoped.row)">不通过</el-button>
          </div>
          <div style="display: flex;align-items: center;justify-content: center;color:#06CC00" v-if="scoped.row.checkStatus == 1">
              审核通过
          </div> 
          <div style="display: flex;align-items: center;justify-content: center;color: red;" v-if="scoped.row.checkStatus == 2">
              审核不通过
          </div>
        </template>
      </el-table-column> 
       <el-table-column prop="address" label="操作" width="170">
        <template slot-scope="scoped">
          <div style="display: flex;align-items: center;justify-content: center;color:#999" v-if="scoped.row.publishStatus == 0">
              未发布
          </div>
          <div style="color: #06CC00;" v-if="scoped.row.publishStatus == 1">
              <div>已发布</div>
              <div>{{ happenTimeFun(scoped.row.publishDate) }}</div>
          </div> 
        </template>
      </el-table-column> 
      <el-table-column prop="withdrawSum" label="封面" width="100">
        <template slot-scope="scoped">
          <el-image
            style="width: 60px;"
            :src="scoped.row.cover"
            fit="fill"
            :preview-src-list="new Array(scoped.row.cover)"
            @click.stop="handleClickItem"
          />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" width="350" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
     <!-- 表单 -->
     <el-form ref="form" :model="active" label-width="150px" size="mini">
        <el-form-item label="图标">
            <UploadImage ref="image" @upLoadImage='upLoadImage'></UploadImage>
        </el-form-item>
         <el-form-item label="封面类型">
          <el-radio-group
          style="display: flex"
          v-model="active.coverType"
        >
          <el-radio :label="0">大封面</el-radio>
          <el-radio :label="1">小封面</el-radio>
        </el-radio-group>
        </el-form-item>
         <el-form-item label="标题">
          <el-input type="textarea" :rows="4" v-model="active.title" placeholder="请输入标题"/>
        </el-form-item>
        <el-form-item label="内容">
          <vue-ueditor-wrap v-model="active.content" :config="config" class="ueditor"/>
        </el-form-item>
        <el-form-item label="内容配图">
            <UploadImage ref="image2" @upLoadImage='upLoadImage2'></UploadImage>
            <span style="color:#999;">该配图会自动替换内容的“image”位置</span>
        </el-form-item>
         <el-form-item label="封面类型">
          <el-radio-group style="display: flex" v-model="active.checkStatus">
            <el-radio :label="0">未审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >添加</el-button>
        </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
     <!-- 编辑用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="50%"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
     <!-- 表单 -->
     <el-form ref="form" :model="editForm" label-width="150px" size="mini">
        <el-form-item label="图标">
            <UploadImage ref="image1" @upLoadImage='upLoadImage1'></UploadImage>
        </el-form-item>
        
         <el-form-item label="封面类型">
          <el-radio-group style="display: flex" v-model="editForm.coverType">
            <el-radio :label="0">大封面</el-radio>
            <el-radio :label="1">小封面</el-radio>
          </el-radio-group>
        </el-form-item>
         <el-form-item label="标题">
          <el-input type="textarea" :rows="4" v-model="editForm.title" placeholder="请输入标题"/>
        </el-form-item>
        <el-form-item label="内容">
          <vue-ueditor-wrap v-model="editForm.content" :config="config" class="ueditor"/>
        </el-form-item>
        <el-form-item label="内容配图">
            <UploadImage ref="image4" @upLoadImage='upLoadImage4'></UploadImage>
            <span style="color:#999;">该配图会自动替换内容的“image”位置</span>
        </el-form-item>
         <el-form-item label="封面类型">
          <el-radio-group style="display: flex" v-model="editForm.checkStatus">
            <el-radio :label="0">未审核</el-radio>
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="communityUpdate()">
          <el-button
            slot="reference"
            type="primary"
            class="edit-button"
          >更新</el-button>
        </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="popupShow"
      width="80%"
      title="预览"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
     <!-- 表单 -->
     <div>
      <ul class="infinite" v-infinite-scroll="load" style="overflow:auto">
          <div v-html="content"></div>
       </ul>
       <div style="display: flex;align-items: center;justify-content: center;" v-if="editForm.checkStatus == 0">
          <el-button type="primary" style="width: 120px;background: #04BF16;border:none;" size="mini"  @click="checkSuccessList(1,editForm)" >审核通过</el-button>
          <el-button type="primary" style="width: 120px;background: #FF0000;border:none;" size="mini"  @click="checkRejectList(1,editForm)" >不通过</el-button>
       </div>
     </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap,UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], // 
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      sn:'',
      lang:'en',
      isEnabled:false,
      isChat:false,
      isTelegram:false,
      isWhatsApp:false,
      isMessenger:false,
      isLinkUrl:false,
      isTelegramGroup:false,
      dataTime:['',''],
      yifangId:'',
      config: {
      // UEDITOR_HOME_URL: process.env.VUE_APP_BASE_URL+'/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。
      // UEDITOR_HOME_URL: "/normalManager/ueditor/", // 需要令此处的URL等于对应 ueditor.config.js 中的配置。本地
      UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。服务器
      autoHeightEnabled: false,
      initialFrameHeight: 450,
      initialFrameWidth: 400,
      maximumWords: 9999999,
      toolbars: [
        [
          'fullscreen',
          'source',
          '|',
          'undo',
          'redo',
          '|',
          'bold',
          'italic',
          'underline',
          'fontborder',
          'strikethrough',
          'removeformat',
          '|',
          'forecolor',
          'backcolor',
          'insertorderedlist',
          'insertunorderedlist',
          'lineheight',
          '|',
          'paragraph',
          'fontfamily',
          'fontsize',
          '|',
          'justifyleft',
          'justifycenter',
          'justifyright',
          'justifyjustify',
          '|',
          'simpleupload',
          'insertimage',
          'emotion',
          '|',
          'link',
          'unlink'
        ]
      ],
      // initialFrameWidth:3000,
      zIndex: 3000,
      // serverUrl: '',
      serverUrl: `/gw/admin/file/ueditor/upload`,
      enableAutoSave: true // 开启从草稿箱恢复功能需要手动设置固定的 editorId，否则组件会默认随机一个，如果页面刷新，下次渲染的时候 editorId 会重新随机，导致无法加载草稿箱数据
      // BaseUrl: process.env.VUE_APP_BASE_URL,
    },
    popupShow:false,
    content:'',
    checkStatus:'',
    publishStatus:'',
    title:''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    editPopup(row){
      this.popupShow = true
      this.editForm = row
      let content = row.content
      let content1 = ''
      if (this.editForm.image) {
        if (content.indexOf('<image>') != -1) {
          content1 = content.replace(/<image>/gi,`<img style="width: 100%;" src='${this.editForm.image}' alt=""></img>`)
          this.content = content1
        }else{
          this.content = content
        }
      }else{
        this.content = content
      }
    },
    upLoadImage(img){
        this.active.cover = img
    },
    upLoadImage1(img){
        this.editForm.cover = img
    },
    upLoadImage2(img){
        this.active.image = img
    },
    upLoadImage4(img){
        this.editForm.image = img
    },
     communityUpdate() {
      let editForm = {
          cover:this.editForm.cover,
          image:this.editForm.image,
          checkStatus:this.editForm.checkStatus,
          coverType:this.editForm.coverType,
          title:this.editForm.title,
          content:this.editForm.content,
          id: this.editForm.id
      }
      this.$api.operate
        .articleUpdate(editForm)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.edit_dialogVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    checkSuccessList(type,row){
      var params = {
          id: row.id
      };
    this.$api.operate
      .articleCheckSuccess(params)
      .then((res) => {
        this.$message.success(res);
        this.popupShow = false
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      });
      
    },
  checkRejectList(type,row){
      var params = {
          id: row.id
      };
    this.$api.operate
      .articleCheckReject(params)
      .then((res) => {
        this.$message.success(res);
        this.popupShow = false
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      });
   
  },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        checkStatus: this.checkStatus,
        publishStatus: this.publishStatus,
        title: this.title,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.operate
        .articleList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .articleDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
        this.active = {}
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.image.init('');
      });
    },
     // 打开编辑弹窗
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
       this.$nextTick(() => {
        this.$refs.image1.init(this.editForm.cover);
        this.$refs.image4.init(this.editForm.image);
      });
      this.edit_dialogVisible = true;
    },
    happenTimeFun(num){
    let date = new Date(num);
    //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM; //月补0
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d; //天补0
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h; //小时补0
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m; //分钟补0
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s; //秒补0
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
},
    // 添加用户
    bannerSave() {
          this.$api.operate
            .articleSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .edui-combox-body{
display: flex !important;
}
::v-deep .el-form-item--mini .el-form-item__content{
line-height: 16px !important;
}
// ::v-deep .edui-editor-iframeholder{
//   background: #000 !important;
// } 
.infinite{
  width: 100%;
  height: 500px;
  background-color: #102F2B;
  color: #fff;
  padding: 0 20px !important;

}
</style>
